import { useLingui } from '@lingui/react';
import { Grid } from '@mantine/core';
import { ProfileBalance } from './ProfileBalance';
import { ProfileReferralCode } from './ProfileReferralCode';
import { ProfileRewards } from './ProfileRewards';
import { ProfileUserCard } from './ProfileUserCard';
export const ProfileUser: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Grid gutter={{
    base: 16,
    sm: 20
  }}>
      <Grid.Col span={{
      base: 12,
      lg: 4
    }}>
        <ProfileUserCard />
      </Grid.Col>
      <Grid.Col span={{
      base: 12,
      lg: 8
    }}>
        <Grid gutter={{
        base: 16,
        sm: 20
      }}>
          <Grid.Col span={{
          base: 12,
          sm: 6
        }}>
            <ProfileBalance title={i18n._('Balance')} value={1443776} />
          </Grid.Col>
          <Grid.Col span={{
          base: 12,
          sm: 6
        }}>
            <ProfileBalance title={i18n._('PRLL Balance')} value={1234.331} />
          </Grid.Col>
          <Grid.Col span={{
          base: 12,
          md: 6
        }}>
            <ProfileReferralCode />
          </Grid.Col>
          <Grid.Col span={{
          base: 12,
          md: 6
        }}>
            <ProfileRewards />
          </Grid.Col>
        </Grid>
      </Grid.Col>
    </Grid>;
};